/**
 * Categoría en Academy (knowledgepages) para el manual «Pautas en exteriores».
 * Debe coincidir con el seed `seed-wiki-pautas-exteriores.js`.
 */
export const WIKI_PAUTAS_EXTERIORES_CATEGORY = 'wiki-pautas-exteriores-tno';

export const WIKI_PAUTAS_EXTERIORES_HERO_SLUG = 'wiki-ext-hero';
